/**
 * External dependencies
 */
import { css } from '@emotion/react';

export const Truncate = css`
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
